import type { IState } from '../reducers/services';
import { getServices } from '../selectors/services';

import { useAppSelector } from './redux';

export const useServices = (): IState['list'] => useAppSelector(getServices);
